export default __webpack_public_path__ + "static/media/claudia.eca17f0f.jpg";